import { useEffect, useState } from "react";
import { logout, checkAuth } from "../../api/auth";
import ProductForm from "../components/ProductForm";
import { ProductList } from "../components/ProductList";
import SiteSettings from "../components/SiteSettings";
import StatsDashboard from "../components/StatsDashboard";
import UserManagement from "../components/UserManagement";
import { useNavigate } from "react-router-dom";

export default function AdminDashboard() {
  const [user, setUser] = useState(null);
  const [activeSection, setActiveSection] = useState("add-product");
  const navigate = useNavigate();

  useEffect(() => {
    checkAuth().then(setUser);
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/admim/login");
    } catch (error) {
      console.error("logout error:", error);
    }
  };

  if (!user) return <p>Chargement</p>;
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: "#121212",
        color: "#00ff00",
        fontFamily: '"Press Start 2P", cursive',
      }}
    >
      {/* Side menu */}
      <div
        style={{
          width: "200px",
          backgroundColor: "#1a1a1a",
          borderRight: "2px solid #00ff00",
          padding: "20px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>ADMIN</h2>
        <ul style={{ listStyle: "none", padding: 0 }}>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #00ff00",
              color: activeSection === "add-product" ? "#ff0" : "#00ff00",
            }}
            onClick={() => setActiveSection("add-product")}
          >
            Ajouter Produit
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #00ff00",
              color: activeSection === "edit-product" ? "#ff0" : "#00ff00",
            }}
            onClick={() => setActiveSection("edit-product")}
          >
            Modifier Produit
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #00ff00",
              color: activeSection === "settings" ? "#ff0" : "#00ff00",
            }}
            onClick={() => setActiveSection("settings")}
          >
            Paramètres du site
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #00ff00",
              color: activeSection === "stats" ? "#ff0" : "#00ff00",
            }}
            onClick={() => setActiveSection("stats")}
          >
            Stats
          </li>
          <li
            style={{
              padding: "10px",
              cursor: "pointer",
              borderBottom: "1px solid #00ff00",
              color: activeSection === "users" ? "#ff0" : "#00ff00",
            }}
            onClick={() => setActiveSection("users")}
          >
            Gestion Utilisateurs
          </li>
        </ul>
              <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button
          onClick={handleLogout}
          style={{
            padding: "8px 16px",
            backgroundColor: "#ff79c6",
            color: "#1e1e2c",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
            fontFamily: '"Press Start 2P", cursive',
            fontSize: "0.7rem",
            width: "100%",
          }}
        >
          LOGOUT
        </button>
      </div>
      </div>


      {/* Main */}
      <div style={{ flex: 1, padding: "30px" }}>
        {activeSection === "add-product" && <ProductForm />}
        {activeSection === "edit-product" && <ProductList />}
        {activeSection === "settings" && <SiteSettings />}
        {activeSection === "stats" && <StatsDashboard />}
        {activeSection === "users" && <UserManagement />}
      </div>
    </div>
  );
  // return (
  //   <div>
  //     <ProductForm></ProductForm>
  //     {/* <p>Ruoli: {user.roles.join(", ")}</p> */}
  //   </div>
  // );
}
